import { Button, Stack, SvgIcon, Typography } from "@mui/material"
import { darken } from "@mui/material/styles"
import theme from "@skistarab/mui-theme"

import MemberLogoIcon from "@/assets/icons/MemberLogo.svg?react"
import { useWebAdminTranslations } from "@/hooks"

import BannerLayout from "../BannerLayout"

export interface MemberBannerProps {
  text: string
  isLoggedOut: boolean
}

const MemberBanner = ({ text, isLoggedOut }: MemberBannerProps) => {
  const { t } = useWebAdminTranslations()

  const loginUrl = t("[SKIPASS_MEMBER_BANNER_LOGIN_URL]")
  const myPageUrl = t("[SKIPASS_MEMBER_BANNER_MY_PAGE_URL]")
  const currentUrl = encodeURIComponent(window.location.href)

  const getLoginWithReturnUrl = (returnUrl: string) =>
    `${loginUrl}?returnUrl=${returnUrl}`

  const loginWithReturnUrl = getLoginWithReturnUrl(currentUrl)
  const joinWithReturnUrl = getLoginWithReturnUrl(myPageUrl)

  return (
    <BannerLayout
      bgcolor="#710325"
      color="white"
      rowGap={1}
      columnGap={10}
      direction={{ xs: "column", md: "row" }}
      alignItems={{ xs: "flex-start", md: "center" }}
      p={{ xs: "12px", md: "8px" }}
      px={{ md: "20px" }}
    >
      <Stack
        direction={{ xs: "column", md: "row" }}
        alignItems={{ xs: "flex-start", md: "center" }}
        columnGap={2}
        rowGap={1}
      >
        <MemberLogo />
        <Typography variant="inherit">{text}</Typography>
      </Stack>
      {isLoggedOut && (
        <Stack direction="row" spacing={1} flex="none">
          <Button
            component="a"
            href={joinWithReturnUrl}
            size="small"
            variant="outlined"
            sx={{
              color: "white",
              borderColor: "white",
              "&:hover": {
                backgroundColor: "rgba(0,0,0,0.2)",
              },
            }}
          >
            {t("[SKIPASS_MEMBER_BANNER_JOIN]")}
          </Button>
          <Button
            component="a"
            href={loginWithReturnUrl}
            size="small"
            variant="contained"
            sx={{
              bgcolor: "white",
              color: "#BA0C2F",
              "&:hover": {
                bgcolor: darken("#ffffff", 0.08),
              },
            }}
          >
            {t("[SKIPASS_MEMBER_BANNER_LOGIN]")}
          </Button>
        </Stack>
      )}
    </BannerLayout>
  )
}

const MemberLogo = () => {
  return (
    <SvgIcon
      component={MemberLogoIcon}
      aria-hidden="true"
      inheritViewBox
      sx={{
        width: 100,
        height: 16,
        [theme.breakpoints.down("sm")]: {
          width: 87,
          height: 14,
        },
      }}
    />
  )
}

export default MemberBanner
